import { createSlice } from '@reduxjs/toolkit'
import { userAuthApi } from '../services/userAuthApi.js';

const initialState = {
  token: '',
  user: null,
}

export const authSlice = createSlice({
  name: 'authInfo',
  initialState,
  reducers: {
     setAuthInfo:(state, action)=> {
        state.token = action.payload.token;
        state.user = action.payload.user;
      },
      unsetAuthInfo:(state, action)=> {
        state.token = action.payload.token;
        state.user = action.payload.user;
     },
     
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        userAuthApi.endpoints.loginUser.matchFulfilled,
        (state, { payload }) => {
          state.user = payload.data;
        }
      )
      .addMatcher(userAuthApi.endpoints.loginUser.matchRejected, (state) => {
        state.user = null;
      })
  }
})

export const { setAuthInfo, unsetAuthInfo } = authSlice.actions

export default authSlice.reducer